import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=1620874e&scoped=true&lang=pug&"
import script from "./Request.vue?vue&type=script&lang=js&"
export * from "./Request.vue?vue&type=script&lang=js&"
import style0 from "./Request.vue?vue&type=style&index=0&id=1620874e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620874e",
  null
  
)

export default component.exports